"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportCategoriesDialog = void 0;
var React = require("react");
var dialog_1 = require("../dialog");
var importCategoriesContext_1 = require("../../context/admin/importCategoriesContext");
var typestyle_1 = require("typestyle");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var checkbox3Tree_1 = require("../lib/checkbox3Tree");
var iterUtils_1 = require("../lib/iterUtils");
var ImportCategoriesDialog = function (props) {
    return (React.createElement(importCategoriesContext_1.default.Consumer, null, function (context) {
        return React.createElement(dialog_1.Dialog, { isOpen: context.isOpen, isReady: context.isReady, contentLabel: gettext("Import Categories"), shouldCloseOnOverlayClick: true, onClose: context.closeDialog, forcedWidth: "550px" },
            React.createElement("div", { className: (0, typestyle_1.classes)("Dialog__ScrollWrapper", "ImportCategoriesDialog") },
                React.createElement("label", { className: "gm--fullwidth" },
                    gettext("Project"),
                    ":",
                    React.createElement(generic_1.ChoiceSelect, { choices: context.project_choices, value: context.selected_project, onChange: function (e) {
                            return context.onProjectSelect(e.currentTarget.value);
                        } })),
                context.selected_project &&
                    React.createElement("div", null,
                        gettext("Categories"),
                        ":",
                        React.createElement(checkbox3Tree_1.Checkbox3Tree, { nodes: context.category_choices.map(function (category) {
                                var checked = (0, iterUtils_1.contains)(context.selected_categories, category.value);
                                var intermediate = checked && !category.children.reduce(function (allChecked, tag) {
                                    return allChecked && (0, iterUtils_1.contains)(context.selected_tags, tag.value);
                                }, true);
                                return {
                                    value: category.value,
                                    labelText: category.display_name,
                                    indeterminate: intermediate,
                                    checked: checked,
                                    onChange: function (e) {
                                        return context.onCategorySelect(category, e.target.checked);
                                    },
                                    childNodes: category.children.map(function (tag) { return ({
                                        value: tag.value,
                                        labelText: tag.display_name,
                                        checked: (0, iterUtils_1.contains)(context.selected_tags, tag.value),
                                        onChange: function (e) {
                                            return context.onTagSelect(category, tag, e.target.checked);
                                        },
                                    }); })
                                };
                            }) }))),
            React.createElement(generic_1.FloatRight, null,
                React.createElement(buttons_1.PrimaryButton, { onClick: function () { return context.onSave().then(props.onSaveSuccess); } }, gettext("Save"))));
    }));
};
exports.ImportCategoriesDialog = ImportCategoriesDialog;
